import type { FC } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon';
import { IconButton } from '../icon-button';
import type { CalendarControlButtonPropsInterface } from './types/calendar-control-button.types';

export const CalendarControlButton: FC<CalendarControlButtonPropsInterface> = (props) => {
  const { children, ...rest } = props;

  return (
    <IconButton
      data-c11n-component="Calendar.ControlButton"
      data-c11n-version={__C11N_VERSION__}
      size="sm"
      shape="circle"
      tone="neutral"
      emphasis="bare"
      {...rest}
      className={cx('c11n_calendar__control-button', rest.className)}
    >
      <Icon>{children}</Icon>
    </IconButton>
  );
};

CalendarControlButton.displayName = 'Calendar.ControlButton';
